/**
 * @ngdoc controllers
 * @memberof mercury.modules.time
 * @name TimePayrunOutstandingCtrl
 */
angular.module('mercury.modules.time.payroll.payrun')
.controller('TimePayrollPayrunOutstandingCtrl', ["dialog", "$scope", "TimePayrollPayruns", "title", function(dialog, $scope, TimePayrollPayruns, title) {
  title.set('Outstanding Payruns');
  console.log('entered payruns controller');
  $scope.loading = TimePayrollPayruns.getOutstanding();
  $scope.loading.then(function(result) {
    console.log('loading promise resolved');
    $scope.payruns = result;
  });

  $scope.newPayrun = function() {
    dialog.open({
      templateUrl: 'modules/time/payroll/payrun/create.tpl.html',
      controller: 'TimePayrollPayrunCreateCtrl'
    });
  };
  console.log('end of payrun Outstanding controller');
}]);
